// extracted by mini-css-extract-plugin
export default {"container":"OverviewBanner_container__Sq0HM","wrapper":"OverviewBanner_wrapper__N-wVK","element":"OverviewBanner_element__xUfKo","value":"OverviewBanner_value__AZMC8"};